var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.aggregator.table && _vm.aggregator.headers)?_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.aggregator.name))]),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.aggregator.headers,"items":_vm.aggregator.table,"hide-default-footer":"","disable-pagination":""}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49958085","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/SingleAggregatorTable.vue
// module id = null
// module chunks = 